function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M234 145.1V70.9H49.5v14.8C26.3 81.8 4.4 97.4.6 120.6s11.8 45.1 34.9 48.9c5.7 1 11.5.7 17.2-.7 7 25.2 24.5 46.3 48 57.8H49.5V255h184.3v-28.3h-51c30.3-15 51.2-45.9 51.2-81.6zM28.5 127.6c0-7.7 6.2-14 14-14 2.5 0 4.9.6 7 1.9v24.3c-6.7 3.9-15.3 1.6-19.1-5.1-1.3-2.2-1.9-4.7-1.9-7.1zm177 17.5c0 34.5-28.6 62.5-63.7 62.5S78 179.6 78 145.1V99.4h127.5v45.7z"
})));